import React from "react";
import ResizeObserver from "resize-observer-polyfill";

export function useHideResize(msDelay = 300) {
  const [isResizing, setIsResizing] = React.useState(false);
  const [first, setFirst] = React.useState(true);
  const [ref, setRef] = React.useState<HTMLDivElement | null>(null);
  const countdown = React.useRef<any>(null);
  const prevWidth = React.useRef<number>(0);

  const observer = React.useRef<null | ResizeObserver>(null);

  React.useEffect(() => {
    if (observer.current) observer.current.disconnect();

    observer.current = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      window.requestAnimationFrame(() => {
        if (!entries) return;
        entries.forEach(entry => {


        if (
          !first &&
          Math.abs(entry.contentRect.width - prevWidth.current) > 25
        ) {
          setIsResizing(true);
          if (countdown.current) clearTimeout(countdown.current);
          countdown.current = setTimeout(() => setIsResizing(false), msDelay);
        }

        setFirst(false);
        prevWidth.current = entry.contentRect.width;
        });
      });
    });

    const { current: currentObserver } = observer;

    if (ref) currentObserver.observe(ref);

    return () => currentObserver.disconnect();
  }, [ref, first, msDelay]);

  const bind = React.useMemo(() => ({ ref: setRef }), []);

  return [bind, isResizing] as [{ ref: typeof setRef }, typeof isResizing];
}
